import React from 'react';
import { convertDigitToProperFormat } from 'utils/number';
import { NumberOrNull } from 'store/entity/types';
import {
  IGridQuestionView,
  ISurveyViewServer,
  ISurveyViewWithData,
} from 'store/survey/surveyTypes';
import messages from './Messages';
import RelatedResponsesQuestionTags from './RelatedResponsesQuestionTags';
import HoverIcon from 'components/HoverIcon';
import {
  ItemRow,
  Item,
  Title,
  SubAnswerItem,
  SubAnswersCounts,
  GridSubAnswerAction,
  SubAnswerItemsContainer,
  RelatedResponseQuestionTitle,
} from 'components/FileManager/ItemsViewer/Survey/SurveyResponseViewer/styles';
import { QuestionItems } from './styles';

interface IComponentProps {
  surveys?: ISurveyViewServer[];
  selectedTags: number[];
  gridPartValue?: string;
  selectedQuestionId: NumberOrNull;
  onClickOnQuestion: (
    surveyId: number,
    questionId: number,
    gridPartValue?: string
  ) => () => void;
  survey?: ISurveyViewWithData;
}

interface IComponentStates {
  [gridQuestionId: number]: boolean;
}

class QuestionList extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  state: IComponentStates = {};

  handleSubAnswersView =
    (surveyId: number, questionId: number) =>
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation();
      this.setState(
        (prevState) => ({
          [questionId]: !prevState[questionId],
        }),
        () => {
          // to unselect selected grid part on collapse question
          if (!this.state[questionId] && this.props.selectedQuestionId) {
            this.props.onClickOnQuestion(surveyId, questionId)();
          }
        }
      );
    };

  render() {
    if (!this.props.surveys) {
      return <div>there is nothing to show</div>;
    }
    const {
      surveys,
      selectedTags,
      gridPartValue,
      onClickOnQuestion,
      selectedQuestionId,
    } = this.props;
    return (
      <QuestionItems>
        {surveys.map((survey) => {
          const hasSelectedTags = selectedTags && selectedTags.length > 0;
          const surveyQuestionList =
            survey.id === this.props.survey?.data?.id // use viewing version if specific survey selected
              ? this.props.survey.data.versions[
                  this.props.survey.viewingVersion!
                ]?.questionList || survey.surveyQuestionList
              : survey.surveyQuestionList;

          const filteredSurveyQuestionList = hasSelectedTags
            ? surveyQuestionList.filter((question) => {
                if (!question.deleted) {
                  if (hasSelectedTags) {
                    return (
                      question.tags &&
                      selectedTags.every((selectedTagId) =>
                        question.tags.some(
                          (questionTag) => selectedTagId === questionTag.id
                        )
                      )
                    );
                  }
                  return true;
                }
                return false;
              })
            : surveyQuestionList;
          return filteredSurveyQuestionList
            .slice()
            .sort((a, b) => {
              return a.order - b.order;
            })
            .map((question) => (
              <div key={question.id}>
                <Item
                  isActive={selectedQuestionId === question.id}
                  onClick={onClickOnQuestion(survey.id, question.id)}
                >
                  <ItemRow>
                    <RelatedResponseQuestionTitle>
                      <Title color="blue">{question.title}</Title>
                      {question.tags && (
                        <RelatedResponsesQuestionTags
                          questionTags={question.tags}
                        />
                      )}
                      {question.type === 'grid' &&
                        question.parts.length > 0 && (
                          <GridSubAnswerAction>
                            <SubAnswersCounts>
                              {messages.countOfGridParts(
                                convertDigitToProperFormat(
                                  question.parts.length
                                )
                              )}
                            </SubAnswersCounts>
                            <HoverIcon
                              color="blue"
                              onClick={this.handleSubAnswersView(
                                survey.id,
                                question.id
                              )}
                              type={
                                this.state[question.id]
                                  ? 'chevron-up' // to collapse question
                                  : 'chevron-down' // to open question
                              }
                            />
                          </GridSubAnswerAction>
                        )}
                    </RelatedResponseQuestionTitle>
                  </ItemRow>
                </Item>
                {this.state[question.id] && (
                  <SubAnswerItemsContainer>
                    {(question as IGridQuestionView).parts.map((part) => (
                      <SubAnswerItem
                        key={part.value}
                        onClick={onClickOnQuestion(
                          survey.id,
                          question.id,
                          part.value
                        )}
                        isActive={part.value === gridPartValue}
                      >
                        {part.text}
                      </SubAnswerItem>
                    ))}
                  </SubAnswerItemsContainer>
                )}
              </div>
            ));
        })}
      </QuestionItems>
    );
  }
}

export default QuestionList;
